export default "__VITE_ASSET__Ddw6e4kZ__"